import { render, staticRenderFns } from "./pagefour.vue?vue&type=template&id=64fef70a&scoped=true&"
import script from "./pagefour.vue?vue&type=script&lang=js&"
export * from "./pagefour.vue?vue&type=script&lang=js&"
import style0 from "./pagefour.vue?vue&type=style&index=0&id=64fef70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fef70a",
  null
  
)

export default component.exports